import {Component, computed, inject, OnInit} from '@angular/core';
import {generateAuditAction} from "../../core/store/audit/audit.actions";
import {Store} from "@ngrx/store";
import {getAuditCompletedCredits} from "../../core/store/audit/audit.selectors";

@Component({
  selector: 'app-header-bar',
  templateUrl: './header-bar.component.html',
  styleUrls: ['./header-bar.component.scss'],
  standalone: false
})
export class HeaderBarComponent implements OnInit {

  private store = inject(Store);

  protected creditProgress = this.store.selectSignal(getAuditCompletedCredits);

  protected creditProgressText = computed<string>(() => {
    return `CSER Progress (${this.creditProgress()} Credit${this.creditProgress() === 1 ? '' : 's'})`;
  });

  ngOnInit(): void {
    this.store.dispatch(generateAuditAction());
  }

}
